import React from 'react';
import dynamic from "next/dynamic";

const AboutHero = dynamic(() => import("./AboutHero"));
const Story = dynamic(() => import("./Story"));
const AboutUsInfo = dynamic(() => import("./AboutUsInfo"));
const FirstBlock = dynamic(() => import("./FirstBlock"));

const Index = () => {
  return (
    <>
      <AboutHero/>
      <FirstBlock/>
      <AboutUsInfo/>
      <Story/>
    </>
  );
};

export default Index;